import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import { VueHammer } from 'vue2-hammer'
import Vue2TouchEvents from 'vue2-touch-events'
import PortalVue from 'portal-vue'
import VueCookies from 'vue-cookies'
import VueMasonry from 'vue-masonry-css'
import VueStickto from 'vue-stickto'
import VueScrollTo from 'vue-scrollto'
// import VueGtag from "vue-gtag";
import VueMatomo from 'vue-matomo'

import SocialSharing from 'vue-social-sharing'

import VueI18n from 'vue-i18n'
import { languages, defaultLocale } from './i18n/index.js'

import VueTour from 'vue-tour'
import 'vue-tour/dist/vue-tour.css'

import '@/styles/main.sass'

Vue.use(VueHammer)
VueHammer.customEvents = {
  doubletap: { type: 'tap', event: 'doubletap', taps: 2 },
  singletap: { type: 'tap', event: 'singletap', requireFailure: ['doubletap'] }
}

Vue.use(VueI18n)

const messages = Object.assign(languages)

// if locale is not specified, redirect to fallback locale url
let request_path = window.location.pathname.replace(/^\/([^/]+).*/i, '$1');
const slug_locale = request_path.split( /(?<=^[^/]+),/ );
let locale
if(Object.keys(languages).some((item => item === slug_locale[0]))){
  locale = slug_locale[0]
} else {
  locale = defaultLocale
  window.location.href = '/' + defaultLocale + window.location.pathname
}

// locale setting
const i18n = new VueI18n({
  locale: locale,
  fallbackLocale: 'en',
  messages
});


Vue.use(Vue2TouchEvents, {tapTolerance: 1})
Vue.use(PortalVue)
Vue.use(VueCookies)
Vue.use(VueMasonry)
Vue.use(VueStickto)
Vue.use(VueScrollTo)
Vue.use(VueTour)
Vue.use(SocialSharing)

// Vue.use(VueGtag, {
//   config: { id: process.env.VUE_APP_GA_ID }
// }, router);

Vue.use(VueMatomo, {
  host: 'https://wa.artmuseums.go.jp/matomo/',
  siteId: 10,
  trackerFileName: 'matomo',
  router: router,
  enableLinkTracking: true,
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  created () {
    // for debug, clear all vue state
    // this.$store.replaceState({})
    window.localStorage.clear()
    document.oncontextmenu = () => { return false }
    // console.log(process.env.VUE_APP_BASE_URL)
    // console.log(process.env.VUE_APP_ROOT_API)
  }
}).$mount('#app')
